import http from "@/settings/apiSettings"

class DocumenteTipuriDataService {
    getAll(): Promise<any> {
        return http.clientDocumenteOdata.get('DOC_Tipuri')
    }

    getByKey(key) {
        return http.clientDocumenteOdata.get(`DOC_Tipuri(${key})`)
    }

    getPermiseMele(): Promise<any> {
        return http.clientDocumente.get('/DOC_Tipuri/permise-mele')
    }
}

export default new DocumenteTipuriDataService()